import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import '../projects/ProjectPage.css';
import './ResearchDetailPage.css';
import './PhdPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2012-07-25', displayDate: 'July 25, 2012' };

const BASE_URL = process.env.PUBLIC_URL || '';
const DEFENSE_DATE = new Date(Date.UTC(2012, 6, 18, 9, 0, 0, 0));

const formatTimeSince = () => {
  const now = new Date();
  const diffMs = now - DEFENSE_DATE;
  const days = Math.floor(diffMs / 86400000);
  const hours = Math.floor((diffMs % 86400000) / 3600000);
  const mins = Math.floor((diffMs % 3600000) / 60000);
  const secs = Math.floor((diffMs % 60000) / 1000);
  return { days, hours, mins, secs };
};

const PhdPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);
  const [timeSince, setTimeSince] = useState(() => formatTimeSince());

  const committee = [
    { name: 'Dr. Arturo Azcorra Saloña', url: 'http://www.it.uc3m.es/azcorra/indice.html' },
    { name: 'Dr. Josep Paradells Aspas', url: 'http://www-entel.upc.edu/persones/fitxes/josep.paradells.html' },
    { name: 'Dr. Joerg Widmer', url: 'http://fourier.networks.imdea.org/~joerg_widmer/' },
    { name: 'Dr. Gonzalo Camarillo', url: 'http://users.piuha.net/gonzalo/index.html' },
    { name: 'Dr. Iván Vidal Fernández', url: 'http://www.it.uc3m.es/ividal/indice.html' },
  ];

  useEffect(() => {
    const interval = setInterval(() => setTimeSince(formatTimeSince()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let timeoutId;
    const script = document.createElement('script');
    script.src = `${BASE_URL}/research/phd/counter/counter_up.js`;
    script.async = false;
    script.onload = () => {
      timeoutId = setTimeout(() => {
        if (
          typeof window.RunCounter === 'function' &&
          document.getElementById('counterdowndigitdayfirst')
        ) {
          try {
            window.RunCounter();
          } catch (e) {
            console.warn('PhD counter failed:', e);
          }
        }
      }, 100);
    };
    document.body.appendChild(script);
    return () => {
      clearTimeout(timeoutId);
      script.remove();
    };
  }, []);

  const counterStyle = {
    '--phd-digits-down': `url('${BASE_URL}/research/phd/counter/Digits10down.png')`,
    '--phd-digits-up': `url('${BASE_URL}/research/phd/counter/Digits10up.png')`,
    '--phd-digits-03': `url('${BASE_URL}/research/phd/counter/Digits03up.png')`,
    '--phd-digits-06': `url('${BASE_URL}/research/phd/counter/Digits06up.png')`,
  };

  return (
    <div className="project-page research-detail-page" id="top">
      {/* Banner with counters at top */}
      <div
        className="phd-banner"
        style={{
          backgroundImage: `url(${BASE_URL}/images/phd/Banner.png)`,
          ...counterStyle,
        }}
      >
        <div className="phd-counters-wrapper">
        <div id="counterdown" className="phd-counterdown">
          <div className="phd-counterdown-digitgroup phd-counterdowndigitgroup">
            <div id="counterdowndigitdayfirst" className="phd-counterdown-digit counterdowndigit" />
            <div id="counterdowndigitdaysecond" className="phd-counterdown-digit counterdowndigit" />
            <div className="phd-counterdown-text counterdowntext">Days</div>
          </div>
          <div className="phd-counterdown-digitgroup phd-counterdowndigitgroup">
            <div id="counterdowndigithourfirst" className="phd-counterdown-digit counterdowndigit" />
            <div id="counterdowndigithoursecond" className="phd-counterdown-digit counterdowndigit" />
            <div className="phd-counterdown-text counterdowntext">Hours</div>
          </div>
          <div className="phd-counterdown-digitgroup phd-counterdowndigitgroup">
            <div id="counterdowndigitminutefirst" className="phd-counterdown-digit counterdowndigit" />
            <div id="counterdowndigitminutesecond" className="phd-counterdown-digit counterdowndigit" />
            <div className="phd-counterdown-text counterdowntext">Minutes</div>
          </div>
          <div className="phd-counterdown-digitgroup phd-counterdowndigitgroup">
            <div id="counterdowndigitsecfirst" className="phd-counterdown-digit counterdowndigit" />
            <div id="counterdowndigitsecsecond" className="phd-counterdown-digit counterdowndigit" />
            <div className="phd-counterdown-text counterdowntext">Seconds</div>
          </div>
        </div>
        <div className="phd-counter-fallback" aria-hidden="true">
          {String(timeSince.days).padStart(4, '0')}d {String(timeSince.hours).padStart(2, '0')}h{' '}
          {String(timeSince.mins).padStart(2, '0')}m {String(timeSince.secs).padStart(2, '0')}s
          <span className="phd-counter-fallback-label"> since defense</span>
        </div>
        <div id="counterup" className="phd-counterup">
          <div className="phd-counterup-digitgroup4 counterupdigitgroup4">
            <div id="counterupdigitdayfirst" className="phd-counterup-digit counterupdigit" />
            <div id="counterupdigitdaysecond" className="phd-counterup-digit counterupdigit" />
            <div id="counterupdigitdaythird" className="phd-counterup-digit counterupdigit" />
            <div id="counterupdigitdayfourth" className="phd-counterup-digit counterupdigit" />
            <div className="phd-counterup-text counteruptext">Days</div>
          </div>
          <div className="phd-counterup-digitgroup2 counterupdigitgroup2">
            <div id="counterupdigithourfirst" className="phd-counterup-digit counterupdigit" />
            <div id="counterupdigithoursecond" className="phd-counterup-digit counterupdigit" />
            <div className="phd-counterup-text counteruptext">Hours</div>
          </div>
          <div className="phd-counterup-digitgroup2 counterupdigitgroup2">
            <div id="counterupdigitminutefirst" className="phd-counterup-digit counterupdigit" />
            <div id="counterupdigitminutesecond" className="phd-counterup-digit counterupdigit" />
            <div className="phd-counterup-text counteruptext">Minutes</div>
          </div>
          <div className="phd-counterup-digitgroup2 counterupdigitgroup2">
            <div id="counterupdigitsecfirst" className="phd-counterup-digit counterupdigit" />
            <div id="counterupdigitsecsecond" className="phd-counterup-digit counterupdigit" />
            <div className="phd-counterup-text counteruptext">Seconds</div>
          </div>
        </div>
        </div>
      </div>

      <h1 className="title">Peer-to-Peer Television for the IP Multimedia Subsystem</h1>
      <p>Doctoral defense at Carlos III University of Madrid, July 18, 2012.</p>

      <div className="research-infoboxes">
        <div className="research-infobox">
          <div className="research-infobox-title">What</div>
          <div className="research-infobox-content">
            <Link to="/research/phd/dissertation">
              <img src="/images/phd/cover_small.png" alt="Dissertation cover" width={120} height={161} />
            </Link>
            <p>Peer-to-Peer Television for the IP Multimedia Subsystem</p>
            <p><Link to="/research/phd/dissertation">Read online</Link></p>
            <p><a href="/download/PhdDissertation.pdf" target="_blank" rel="noopener noreferrer">Download</a> (PDF/27.8 MB)</p>
          </div>
        </div>
        <div className="research-infobox">
          <div className="research-infobox-title">Where</div>
          <div className="research-infobox-content">
            <p>Universidad Carlos III de Madrid</p>
            <p>Padre Soler Building</p>
            <p>Aula de Grados</p>
            <p><Link to="/research/phd/map" target="_blank" rel="noopener noreferrer">View map</Link></p>
          </div>
        </div>
        <div className="research-infobox">
          <div className="research-infobox-title">When</div>
          <div className="research-infobox-content">
            <p>Wednesday, July 18, 2012</p>
            <p>11:00 AM</p>
          </div>
        </div>
      </div>

      <div className="research-infoboxes">
        <div className="research-infobox">
          <div className="research-infobox-title">The Committee</div>
          <div className="research-infobox-content" style={{ textAlign: 'center' }}>
            {committee.map((m) => (
              <p key={m.name}>
                <a href={m.url} target="_blank" rel="noopener noreferrer" className="external">
                  {m.name}
                </a>
              </p>
            ))}
          </div>
        </div>
        <div className="research-infobox">
          <div className="research-infobox-title">The Presentation</div>
          <div className="research-infobox-content">
            <img src="/images/phd/slides_small.png" alt="Presentation cover slide" width={153} height={120} />
            <p><Link to="/research/phd/presentation">View online</Link></p>
            <p><a href="/download/PhdSlides.ppsx" target="_blank" rel="noopener noreferrer">Download</a> (PPSX/9.02 MB)</p>
          </div>
        </div>
      </div>

      <p className="update">Last updated: July 25, 2012</p>
    </div>
  );
};

export default PhdPage;
